module.exports = __webpack_public_path__ + "img/4.2bd42a0.png";